import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Environment from "../../../Environment/Environment";
import Http from "../../../Http/Http";
import Constants from "../../../Action/Constants";
import Formatter from "../../../Localization/Formatter";
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

class Information extends Component {

  public state = {
    birthtime: new Date(0),
    versionsUpdates: [],
    isFetchingUpdates: true
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    Http.get("version").then(res => {
      this.setState({
        birthtime: new Date(res.data.birthtime)
      });
    });

    this.props.dispatch({
      type: Constants.GLOBAL_VERSIONS_UPDATE_LIST,
      onSuccess: (versionsUpdates) => {
        this.setState({
          versionsUpdates: versionsUpdates,
          isFetchingUpdates: false
        });
      }
    });
  }

  public getBackendInformation(): any {
    return (
      <div>
        <p style={{fontSize: "20px", fontWeight: 500}}>Backend</p>
        <p>Build Date: {this.state.birthtime.toISOString()}</p>
      </div>
    );
  }

  public getFrontendInformation(): any {
    const environment = Environment.get();

    if (Environment.isRenderedByWebpack()) {
      return (
        <div style={{fontSize: "20px", fontWeight: 500}}>
          <p>Frontend</p>
          <p>webpack</p>
        </div>
      );
    }

    return (
      <div>
        <p style={{fontSize: "20px", fontWeight: 500}}>Frontend</p>
        <p>Backend Endpoint: {environment.backendEndpoint}</p>
        <p>Env: {environment.environment}</p>
        <p>Build Date: {new Date(environment.buildDate).toISOString()}</p>
        <p>Renderer: {environment.renderer}</p>
      </div>
    );
  }

  public renderVersionsUpdates = () => {
    return this.state.versionsUpdates.map(update => {
      return (
        <div className="component-wrapper no-margin-top">
          <div className="component">
            <Card className="card" style={{padding: "20px 60px"}}>
              <p style={{color: "gray"}}>{Formatter.formatDate(new Date(update.createdAt))}</p>
              <ul>
                {
                  (Object.keys(update.content || {})).map(index => {
                    return typeof update.content[index] === "string" ? <li style={{margin: "10px 0"}}>{update.content[index]}</li> : <li style={{margin: "10px 0"}}>{String(update.content[index])}</li>;
                  })
                }
              </ul>
            </Card>
          </div>
        </div>
      );
    })
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button" style={{padding: "0 40px"}}>
            <div className="inner-wrapper" style={{width: "100%"}}>
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1 style={{padding: "24px 0"}}>{this.trans("title-new")}</h1>
              <div className="button-container">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.redirectBack}
                >
                  {this.trans("button-close")}
                </Button>
              </div>
            </div>
          </div>
        </div>
{/*
        <div className="box component-unit-update">
          <Button
              color="primary"
              onClick={
                () => {
                  this.props.dispatch( 
                    {
                      type: Constants.START_PROCESS,
                      payload: {
                        process: 'createChargesForContracts',
                      }
                    }
                  )
                }
              }
          >
            {this.trans("process/create-charges-for-contracts")}
          </Button>
        </div>

        <div className="box component-unit-update">
          <Button
              color="primary"
              onClick={
                () => {
                  this.props.dispatch( 
                    {
                      type: Constants.START_PROCESS,
                      payload: {
                        process: 'mailChargesWithoutOwnerStatement',
                      }
                    }
                  )
                }
              }
          >
            {this.trans("process/mail-charges-without-owner-statement")}
          </Button>
        </div>
*/}
        <div className="box component-unit-update">
          {
            this.state.isFetchingUpdates && (
              <div style={{position: "relative"}}>
                <div className="component-spinner-wrapper">
                  <CircularProgress />
                </div>
              </div>
            )
          }
          {!this.state.isFetchingUpdates && this.renderVersionsUpdates()}
        </div>

        <div className="right-panel-wrapper">
          <div className="timeline" style={{backgroundColor: "white"}}>
            <div style={{padding: "20px"}}>
              {this.getBackendInformation()}
            </div>
            <div style={{padding: "20px"}}>
              {this.getFrontendInformation()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Information
);
